import styled from 'styled-components';
import {
  default as MUITooltip,
  tooltipClasses,
  TooltipProps as MUITooltipProps,
} from '@mui/material/Tooltip';

interface CustomTooltipProps extends MUITooltipProps {
  textAlign?: string;
  width?: number;
  backgroundColor?: string;
  textColor?: string;
}

const Tooltip = styled(
  ({
    className,
    textAlign,
    width,
    backgroundColor,
    ...props
  }: CustomTooltipProps) => (
    <MUITooltip {...props} classes={{ popper: className }} />
  )
)<{ textAlign?: string; backgroundColor?: string }>`
  & .${tooltipClasses.arrow} {
    color: ${props => props.textColor || '#ffffff'};
    &::before {
      background-color: ${props => props.backgroundColor || '#ffffff'};
      border: 1px solid #dadde9;
    }
  }
  & .${tooltipClasses.tooltip} {
    background-color: ${props => props.backgroundColor || '#ffffff'};
    color: ${props => props.textColor || '#000000'};
    max-width: 350px;
    width: ${props => `${props.width}px` || 'auto'};
    font-size: 14px;
    border: 1px solid #dadde9;
    font-family: 'OptumSans', serif !important;
    text-align: ${props => props.textAlign || 'center'};
  }
`;

export default Tooltip;
